import styled, { css, keyframes  } from 'styled-components';

export const BlogWrapper = styled.section`
  margin: 44px 0 100px;
  position: relative;
  .loader {
    height: 200px;
    display: flex;
    justify-content: center;
  }
  .header {
    .nav {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 40px;
      a {
        font-size: 14px;
        &.store {
          color: #5F7141;
        }
        :last-of-type {
          font-weight: bold;
        }
      }
      svg {
        margin: 0 8px;
        height: 8px;
      }
    }
    .headline {
      font-size: 32px;
      font-weight: 800;
      margin: 0 auto;
      max-width: 700px;
      text-align: center;
    }
    .date {
      font-size: 12px;
      text-align: center;
      margin: 32px 0 36px;
    }
    .scores {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;
      font-size: 20px;
      color: #848484;
      span {
        display: flex;
        align-items: center;
      }
      .wall {
        margin: 0 8px;
      }
      svg {
        margin-left: 8px;
      }
    }
  }

  @media screen and (max-width: 1160px) {
    .intro {
      max-width: 100%;
    }
  }
  @media screen and (max-width: 960px) {
    margin: 0;
    padding: 32px 0 64px;
    .header {
      .headline {
        font-size: 24px;
      }
    }
  }
  @media screen and (max-width: 740px) {
    padding: 24px 0 64px;
    .header {
      .nav {
        margin-bottom: 24px;
        a {font-size: 12px;}
      }
      .date {
        margin: 24px 0;
        font-size: 10px;
      }
      .scores {
        font-size: 17px;
        margin-bottom: 26px;
      }
    }
  }
`;

export const BlogContent = styled.div`
  max-width: 700px;
  margin: 0 auto;
  .hero {
    position: relative;
    width: 100%;
    aspect-ratio: 2.33 / 1;
    margin-bottom: 44px;
  }
  .customize {
    overflow: hidden;
    p, > div > *, > * {
      overflow: hidden;
    }
    color: #494949;
    * {
      font-size: inherit;
      color: inherit;
      line-height: inherit;
    }
    ul,
    ol {
      color: #494949;
      display: block;
      list-style: disc outside none;
      padding: 0 0 0 16px;
      @media not all and (min-resolution: 0.001dpcm) {
        @supports (-webkit-appearance: none) {
          padding: 0 0 0 18px;
        }
      }
      li {
        list-style: inherit;
      }
    }
    p {
      font-size: 12px;
      line-height: 1.5;
      color: #494949;
    }
    ol {
      list-style-type: decimal;
    }
    &-section {
      margin-bottom: 44px;
    }
  }
  .paragraph {
    max-width: 700px;
    margin: 0 auto;
    &.bold {
      font-weight: 700;
    }
    font-size: 16px;
    line-height: 1.75;
    margin-bottom: 28px;
  }

  blockquote {
    background-color: #eceff1;
    min-height: 356px;
    padding: 40px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      padding-left: 48px;
      border-left: 4px solid #1f1f1f;
      width: 76%;
      max-width: 700px;
      font-size: 32px;
      font-weight: 800;
      color: #1f1f1f;
    }
  }
  @media screen and (max-width: 1160px) {
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    blockquote {
      min-height: 280px;
      p {
        padding-left: 24px;
        font-size: 28px;
      }
    }
  }
  @media screen and (max-width: 740px) {
    .hero {
      margin-bottom: 28px;
    }
    blockquote {
      justify-content: flex-start;
      min-height: unset;
      p {
        margin: 0 20px 0 28px;
        width: 100%;
        font-size: 24px;
      }
    }
    .customize {
      &-section {
        margin-bottom: 40px;
      }
    }
  }
`;
// pictures slider
export const PictureSliderWrapper = styled.div`
  position: relative;
  .swiper-slide {
    height: auto;
  }
  .btn {
    cursor: pointer;
    z-index: 5;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #000;
    background: #fff;
    width: 70px;
    height: 70px;
    transition: 0.5s;
    @media (hover: hover) and (pointer: fine) {
      :hover {
        background: var(--primary);
        color: #fff;
      }
    }
    svg {
      height: 16px;
    }
    &:last-of-type {
      left: unset;
      right: 10%;
    }
  }
  @media screen and (max-width: 740px) {
    /* margin: 48px -16px; */
    .btn {
      left: 4px;
      &:last-of-type {
        right: 4px;
      }
    }
  }
`;
export const PictureSlide = styled.div`
  height: 360px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
`;
export const CommentsAndLikes = styled.div`
  max-width: 700px;
  margin: 0 auto 56px;
  padding-top: 12px;

  .social {
    margin: 0 auto;
    width: max-content;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    button,
    a {
      margin: 0 10px 4px 0;
    }
    span {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background-color: #000;
      color: #fff;
      transition: all.4s ease-in-out;
      :hover {
        background-color: #3e3e3e;
        cursor: copy;
      }
      svg {
        display: block;
        height: 14px;
        width: auto;
      }
    }
  }
  .tags {
    margin-top: 44px;
    border-top: 1px solid #ECEFF1;
    padding-top: 16px;
    display: flex;
    align-items: flex-start;
    h4 {
      color: #58606D;
      font-size: 12px;
      line-height: 24px;
    }
    .flex {
      display: flex;
      flex-wrap: wrap;
    }
    a {
      font-size: 12px;
      font-weight: 500;
      margin-left: 24px;
      line-height: 24px;
    }
  }
  @media screen and (max-width: 740px) {
    margin: 0 auto 40px;
  }
`;
const appear = keyframes`
  0% {
    opacity: .8;
  }

  100% {
    opacity: .5;
  }
`;
export const Vote = styled.div`
  display: flex;
  align-items: center;
  margin: 32px 0 44px;
  .headline {
    font-size: 16px;
    margin-right: 32px;
    font-weight: 500;
  }
  .actions {
    display: flex;
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    :not(:last-of-type) {
      margin-right: 24px;
    }
    &.like span{
      background-color: #BBD78D;
    }
    &.dislike span {
      background-color: #EF8A70;
    }
    span {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #eceff1;
      margin-right: 12px;
      &.loader-svg svg {
        animation: ${appear} .5s ;
      }
    }
    .count {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 740px) {
    margin: 32px 0;
    .headline {
      font-size: 12px;  
      margin-right: 8px;
    }
    .actions {
      margin-left: auto;
      button {
        font-size: 12px;
        :not(:last-of-type) {
          margin-right: 20px;
        }
        span {
          margin-right: 10px;
        }
      }
    }
  }
`;
export const WriteComment = styled.form<any>`
  background-color: #F5F5F5;
  border: 1px solid #EEF0F5;
  border-radius: 12px;
  min-height: 64px;
  margin-bottom: 52px;
  padding: 20px 36px;
  position: relative;
  ${({full}) => full && css`
    textarea { height: 80px!important; }
    button {
      display: block !important;
    }
  `}
  textarea {
    height: 24px;
    display: block;
    width: 100%;
    font-size: 16px;
    border: none;
    background-color: transparent;
    resize: none;
    transition: all.2s;

    ::placeholder {
      color: #58606D;
    }
  }
  button {
    margin-top: 20px;
    display: none;
    background-color: #ECEFF1;
    color: #BCBCBC;
    line-height: 56px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 700;
    pointer-events: none;
    border-radius: 12px;
    transition: all.1s;
    &.active {
      pointer-events: auto;
      background-color: #000;
      color: #fff;
    }
  }
  @media screen and (max-width: 740px) {
    margin-bottom: 32px;
    padding: 20px;
    textarea {
      font-size: 14px;
    }
    button {
      line-height: 48px;
    }
  }
`;


export const CommentList = styled.div<any>`

  .comment {
    overflow: hidden;
    border-bottom: 1px solid #ECEFF1;
    padding-bottom: 30px;
    margin-bottom: 20px;
    transition: all.5s;
    &:nth-child(n + 3) {
      max-height: 0;
      margin: 0;
      padding: 0;
      border: 0;
    }
    .name {
      font-size: 20px;
    }
    .time {
      margin: 12px 0 8px;
      font-size: 12px;
      color: #58606D;
    }
    p {
      font-size: 16px;
      line-height: 1.6;
    }
    .rate {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .delete {
        margin-left: auto;
        color: red;
      }
    }
    .like {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #58606D;
      margin-right: 20px;
      &.liked  button{
        background-color: #BBD78D;
      }
      &.disliked button{
        background-color: #EF8A70;
      }

      button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #ECEFF1;
        color: #000;
        margin-right: 8px;
        &.loader svg {
          /* opacity: .2; */
          animation: ${appear} .5s ;
        }
      }
    }
  }
  ${({full})=> full && css`
    .comment:nth-child(n + 3) {
      border-bottom: 1px solid #ECEFF1;
      padding-bottom: 30px;
      margin-bottom: 20px;
      max-height: 500px;
    }
  `}
  .show-all {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    &.up svg{
      transform: rotate(180deg);
    } 
    svg {
      transition: all.5s;
      margin-left: 8px;
    }
  }
  @media screen and (max-width: 740px) {
    .comment {
      padding-bottom: 16px;
      .name {
        font-size: 18px;
      }
      .time {
        margin: 8px 0;
      }
      p {    font-size: 14px;}
      .rate { margin-top: 16px;}
    }
    ${({full})=> full && css`
      .comment:nth-child(n + 3) {
        padding-bottom: 16px;
      }
    `}
    .show-all {
      font-size: 15px;
    }
  }
`;

// multy slider
export const MultySliderWrapper = styled.div`
  margin: 52px 0 60px;
  .header {
    margin-bottom: 44px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eceff1;
    display: flex;
    align-items: center;
    .title {
      font-size: 24px;
      font-weight: 800;
    }
    .actions {
      margin-left: auto;
      display: flex;
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        border: 1px solid #d4d7d9;
        margin-left: 8px;
        transition: 0.4s;
        color: #000;
        &.swiper-button-disabled {
          color: gray;
          cursor: not-allowed;
        }
        svg {
          display: block;
          height: 14px;
          width: auto;
        }
      }
    }
  }
  .swiper-slide {
    height: auto;
    > div {
      height: 100%;
    }
  }
  @media screen and (max-width: 740px) {
    margin: 40px 0;
    .header {
      align-items: flex-start;
      margin-bottom: 32px;
      padding-bottom: 24px;
      .title {
        font-size: 20px;
      }
    }
    .no-edge {
      margin-right: -16px;
    }
    .image {
      height: 184px !important;
    }
  }
  
`;


export const Copyed = styled.div<any>`
  margin-top: 24px;
  background-color: #1f1f1f;
  line-height: 56px;
  border-radius: 8px;
  width: 100%;
  font-size: 12px;
  color: #fff;
  padding: 0 24px;
  text-align: left;
  transition: 1s;
  opacity: 0;
  ${({ appear }) =>
    appear &&
    css`
      transition: all.3s ease-in;
      opacity: 1;
    `}
`;

const ticker = keyframes`
  0% {
    transform: translate(100%, 0);
  }

  50% {
    transform: translate(0%, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
`;
export const DecorLine = styled.div<any>`
  background-color: var(--primary);
  color: #000;
  height: 32px;
  $duration: 30s;
  position: relative;
  overflow: hidden;
  > div {
    overflow: hidden;
    width: 100%;
    height: 32px;
    transform: translate(100%, 0);
  }
  .first, .second {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    top: 0;
    right: 0;
    animation: ${ticker} 30s infinite linear forwards;
    /* animation: none !important; */
    /* padding-right: 20px; */
  }
  .second {
    animation:30s ${ticker} 15s infinite linear forwards;
    /* background-color: gray; */
  }
  span {
    flex-grow: 0;
    font-size: 18px;
    font-weight: 700;
    min-width: max-content;
    position: relative;
    font-feature-settings: 'case';

    &.dot {
      margin: 0 8px;
    }
  }
  @media screen and (max-width: 1550px) {
    .first, .second {
      /* padding-right: 12px; */
    }
  }
  @media screen and (max-width: 1550px) {
    span {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1320px) {
    span {
      font-size: 12px;
      :nth-of-type(5), :nth-of-type(6){
        display: none;
      }
    }
  }
  @media screen and (max-width: 740px) {
    span {
      font-size: 12px;
      :nth-of-type(3), :nth-of-type(4),:nth-of-type(5), :nth-of-type(6){
        display: none;
      }
    }
  }
  @media screen and (max-width: 380px) {
    span {
      font-size: 11px;
      font-weight: 600;
      &.dot {
        margin: 0 4px;
      }
    }
  }
`;
